module.exports = __webpack_public_path__ + "frontend/images/cards/green/green.png?899c85c725e342dbd1b4938bfb6327d2";